export const BRIEF_AI_CONFIG_QUERY_KEY = (briefId: string, brandId: string) => [
  "brief",
  briefId,
  brandId,
  "ai",
  "config",
];
